<template><div><h3>Previewer_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fpreviewer"/>
<p><a href="https://vux.li/demos/v2/#/component/previewer" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/previewer</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/previewer" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">img</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"previewer-demo-img"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"(item, index) in list"</span> <span class="hljs-attr">:src</span>=<span class="hljs-string">"item.src"</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"show(index)"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">previewer</span> <span class="hljs-attr">:list</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"previewer"</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">@on-index-change</span>=<span class="hljs-string">"logIndexChange"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">previewer</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { Previewer, TransferDom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">directives</span>: {
    TransferDom
  },
  <span class="hljs-attr">components</span>: {
    Previewer
  },
  <span class="hljs-attr">methods</span>: {
    logIndexChange (arg) {
      <span class="hljs-built_in">console</span>.log(arg)
    },
    show (index) {
      <span class="hljs-keyword">this</span>.$refs.previewer.show(index)
    }
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">list</span>: [{
        <span class="hljs-attr">msrc</span>: <span class="hljs-string">'http://ww1.sinaimg.cn/thumbnail/663d3650gy1fplwu9ze86j20m80b40t2.jpg'</span>,
        <span class="hljs-attr">src</span>: <span class="hljs-string">'http://ww1.sinaimg.cn/large/663d3650gy1fplwu9ze86j20m80b40t2.jpg'</span>,
        <span class="hljs-attr">w</span>: <span class="hljs-number">800</span>,
        <span class="hljs-attr">h</span>: <span class="hljs-number">400</span>
      },
      {
        <span class="hljs-attr">msrc</span>: <span class="hljs-string">'http://ww1.sinaimg.cn/thumbnail/663d3650gy1fplwvqwuoaj20xc0p0t9s.jpg'</span>,
        <span class="hljs-attr">src</span>: <span class="hljs-string">'http://ww1.sinaimg.cn/large/663d3650gy1fplwvqwuoaj20xc0p0t9s.jpg'</span>,
        <span class="hljs-attr">w</span>: <span class="hljs-number">1200</span>,
        <span class="hljs-attr">h</span>: <span class="hljs-number">900</span>
      }, {
        <span class="hljs-attr">msrc</span>: <span class="hljs-string">'http://ww1.sinaimg.cn/thumbnail/663d3650gy1fplwwcynw2j20p00b4js9.jpg'</span>,
        <span class="hljs-attr">src</span>: <span class="hljs-string">'http://ww1.sinaimg.cn/large/663d3650gy1fplwwcynw2j20p00b4js9.jpg'</span>
      }],
      <span class="hljs-attr">options</span>: {
        getThumbBoundsFn (index) {
          <span class="hljs-comment">// find thumbnail element</span>
          <span class="hljs-keyword">let</span> thumbnail = <span class="hljs-built_in">document</span>.querySelectorAll(<span class="hljs-string">'.previewer-demo-img'</span>)[index]
          <span class="hljs-comment">// get window scroll Y</span>
          <span class="hljs-keyword">let</span> pageYScroll = <span class="hljs-built_in">window</span>.pageYOffset || <span class="hljs-built_in">document</span>.documentElement.scrollTop
          <span class="hljs-comment">// optionally get horizontal scroll</span>
          <span class="hljs-comment">// get position of element relative to viewport</span>
          <span class="hljs-keyword">let</span> rect = thumbnail.getBoundingClientRect()
          <span class="hljs-comment">// w = width</span>
          <span class="hljs-keyword">return</span> {<span class="hljs-attr">x</span>: rect.left, <span class="hljs-attr">y</span>: rect.top + pageYScroll, <span class="hljs-attr">w</span>: rect.width}
          <span class="hljs-comment">// Good guide on how to get element coordinates:</span>
          <span class="hljs-comment">// http://javascript.info/tutorial/coordinates</span>
        }
      }
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// previewer-399.vue?44f4b97b